<template>
  <div>
    <el-card>
      <div class="flex space_between">
        <div style="width: 60%" class="text_left">
          <div class="flex space_around">
            <el-button
              type="success"
              :plain="status == 2 ? true : false"
              @click="change(1)"
              >显示原文</el-button
            >
            <el-button
              type="success"
              :plain="status == 1 ? true : false"
              @click="change(2)"
              >显示批改后作文</el-button
            >
          </div>
          <br />
          <b class="report_title">
            {{ data.title }}
          </b>
          <br />
          <br />
          <div class="report_article" @click="linktap">
            <span v-html="content" style="white-space: pre-line"></span>
          </div>
        </div>
        <div style="width: 35%">
          <div class="report">
            <p class="score">
              <b
                >{{ data.totalscore
                }}<span style="font-size: 18px"> 分</span></b
              >
            </p>
            <el-card v-if="data.type == 0">
              <div class="flex">
                <div class="text_center" style="flex: 1">
                  <b style="color: #f47a51">{{ data.score.TaskResponse }}</b>
                  <p>任务回应</p>
                </div>
                <div class="text_center" style="flex: 1">
                  <b style="color: #f47a51">{{ data.score.LexicalResource }}</b>
                  <p>词汇丰富性</p>
                </div>
                <div class="text_center" style="flex: 1">
                  <b style="color: #f47a51">{{
                    data.score.GrammaticalRangeandAccuracy
                  }}</b>
                  <p>语言准确性</p>
                </div>
                <div class="text_center" style="flex: 1">
                  <b style="color: #f47a51">{{
                    data.score.CoherenceandCohesion
                  }}</b>
                  <p>语篇衔接与连贯性</p>
                </div>
              </div>
            </el-card>

            <el-card>
              <div class="icon">
                <img
                  height="26"
                  src="https://resource.edc.org.cn/gpt/ic_1.png"
                  alt=""
                />
                <b style="color: #2c81f9">{{
                  data.score.OverallEvaluationOfTheArticle
                    ? '总体评价'
                    : '审题建议'
                }}</b>
              </div>
              <p class="text_left">
                {{
                  data.score.OverallEvaluationOfTheArticle
                    ? data.score.OverallEvaluationOfTheArticle
                    : data.explain
                }}
              </p>
            </el-card>
            <el-card>
              <div class="icon">
                <img
                  height="26"
                  src="https://resource.edc.org.cn/gpt/ic_2.png"
                  alt=""
                />
                <b style="color: #6266f9">高分建议</b>
              </div>
              <p class="text_left">
                {{ data.advice }}
              </p></el-card
            >
          </div>

          <div v-show="show">
            <div
              class="opinion_text"
              :style="{ background: optimizeShow ? '#F79F1F' : '#de3a3d' }"
            >
              {{ num[index] }} {{ comment.text }}
            </div>
            <div class="opinion_modify">
              {{ comment.modify }}
            </div>
            <div class="opinion_reason text_left">
              {{ comment.reason }}
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import { reactive, ref, toRefs, onMounted, watch } from 'vue'
export default {
  props: ['reportData'],
  setup(props) {
    const state = reactive({
      data: {
        score: {},
      },
      num: [
        '①',
        '②',
        '③',
        '④',
        '⑤',
        '⑥',
        '⑦',
        '⑧',
        '⑨',
        '⑩',
        '⑪',
        '⑫',
        '⑬',
        '⑭',
        '⑮',
        '⑯',
        '⑰',
        '⑱',
        '⑲',
        '⑳',
      ],
      content: '',
      comment: {},
      status: 1,
      show: false,
      index: '',
      optimize: [],
      optimizeShow: false,
    })
    onMounted(() => {})
    watch(
      () => props.reportData,
      (newV, oldV) => {
        if (newV) {
          state.data = newV
          state.show = false
          console.log(newV)
          init()
        }
      },
      { deep: true }
    )
    const init = () => {
      getComment()
    }
    const change = e => {
      state.status = e
      if (e == 2) {
        getModel()
      }
      if (e == 1) {
        getComment()
      }
    }
    const getComment = () => {
      let msg = state.data.content
      for (var i = 0; i < state.data.check.length; i++) {
        msg = msg.replace(
          state.data.check[i].text,
          `<a class="${i}" style='background:#FEE5E5;border-bottom:2px solid #DE3A3D;text-decoration:none;margin-left:15px'>${state.num[i]}$&</a>`
        )
      }
      state.optimize = []
      if (!Array.isArray(state.data.optimize)) {
        state.optimize.push(state.data.optimize)
      } else {
        state.optimize = state.data.optimize
      }
      for (var i = 0; i < state.optimize.length; i++) {
        msg = msg.replace(
          state.optimize[i].text,
          `<a class="${i}" name="optimize" style='background:#ffeaa7;border-bottom:2px solid #F79F1F;text-decoration:none;margin-left:15px'>${state.num[i]}$&</a>`
        )
      }
      state.content = msg
    }
    const getModel = () => {
      let msg = state.data.content
      for (var i = 0; i < state.data.check.length; i++) {
        msg = msg.replace(
          state.data.check[i].text,
          `<a style='background:#7bed9f82;text-decoration:none;'>${state.data.check[i].modify}</a>`
        )
      }
      for (var i = 0; i < state.optimize.length; i++) {
        msg = msg.replace(
          state.optimize[i].text,
          `<a style='background:#7bed9f82;text-decoration:none;'>${state.optimize[i].modify}</a>`
        )
      }
      console.log(msg)
      state.content = msg
    }
    const linktap = e => {
      console.log(e.target.name)
      let index = e.target.className
      state.optimizeShow = false
      if (index) {
        state.show = true
        state.comment = state.data.check[index]
        state.index = index
      }
      if (e.target.name == 'optimize') {
        state.comment = state.optimize[index]
        state.optimizeShow = true
      }
    }
    return {
      ...toRefs(state),
      init,
      getComment,
      getModel,
      change,
      linktap,
    }
  },
}
</script>
<style lang="less" scoped>
.report {
  .el-card {
    margin: 10px 0;
  }
}
.report_title {
  font-size: 18px;
}
.report_article {
  line-height: 28px;
  cursor: pointer;
}
.opinion_text {
  background: #de3a3d;
  border-radius: 20px;
  color: #fff;
  padding: 5px 10px;
  text-align: left;
  margin-top: 50px;
}
.opinion_modify {
  background: #2ecc71;
  border-radius: 20px;
  color: #fff;
  padding: 5px 10px;
  text-align: left;
  margin: 15px 0;
}
.opinion_reason {
  margin: 20px 0;
  font-size: 14px;
}
.icon {
  img {
    vertical-align: middle;
    margin-right: 10px;
  }
}
.text_left {
  text-align: left;
}
.score {
  font-size: 42px;
  color: #6266f9;
}
</style>
